import React from 'react';

const Vue_template = () => {
  return (
    <div>
      <h1>Vue_template Component</h1>
      <p>This is the Vue_template tutorial page.</p>
    </div>
  );
}

export default Vue_template;
